// extracted by mini-css-extract-plugin
export default {"inputWrap":"AddHocReports_inputWrap__JwQ11","formControls":"AddHocReports_formControls__UYBJx"};